import Popup from "@/components/Popup/Popup";
import { Button, Stack, TextField } from "@mui/material";
import { FC, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;

  // eslint-disable-next-line no-unused-vars
  onCreate: (name: string) => Promise<void>;
}

const CreateCompanyPopup: FC<Props> = ({ open, onClose, onCreate }) => {
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    if (!name.trim()) return;
    setLoading(true);
    onCreate(name.trim())
      .then(() => setName(""))
      .finally(() => setLoading(false));
  };

  const handleClose = () => {
    setName("");
    onClose();
  };

  return (
    <Popup
      open={open}
      onClose={handleClose}
      title="Nouvelle entreprise"
      modalSize={{ width: 400, height: "auto" }}
      actions={
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button onClick={handleClose}>Annuler</Button>
          <Button variant="contained" onClick={handleSubmit} disabled={!name.trim() || loading}>
            Créer
          </Button>
        </Stack>
      }>
      <TextField
        label="Nom de l'entreprise"
        fullWidth
        size="small"
        value={name}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
        autoFocus
      />
    </Popup>
  );
};

export default CreateCompanyPopup;
